module.exports = __webpack_public_path__ + "media/images/preview_recipe_1-3b2a0a809903fc9603575c0a6fd5a800.webp";